import axios from '../../../services/axiosInstance';
const baseUrl = process.env.REACT_APP_BASE_URL;


export async function getProductos() {
    try {
        const response = await axios.get(`${baseUrl}/productos`);
        return response;
    } catch (error) {
        console.log("Error al obtener productos:", error);
    }
}


export async function getProductoById(id) {
    try {
        const response = await axios.get(`${baseUrl}/productos/${id}`);
        return response;
    } catch (error) {
        console.error(`Error al obtener el producto con ID ${id}:`, error);
        throw error;
    }
}

export async function getProductoBySlug(slug) {
    try {
        const response = await axios.get(`${baseUrl}/productos/slug/${slug}`);
        return response;
    } catch (error) {
        console.error(`Error al obtener el producto con slug ${slug}:`, error);
        throw error;
    }
}
